module.exports = __webpack_public_path__ + "img/red_013.a5a4c894.png";